import axios from "axios";

const endpoint_url = "/message/whatsappAnalytic/getByTemplateUuid";

const getTemplateAnalytic = ({whatsappMessageTemplateUuid}) => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams([['whatsapp_message_template_uuid', whatsappMessageTemplateUuid]]);
    axios
      .get(endpoint_url,{params})
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getTemplateAnalytic;
